<template>
    <div class="table-container">
        <el-table
            :data="companies"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    {{props.row.brief||'-暂无简介-'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="title"
                label="标题"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <div class="name">
                        <el-popover
                        v-if="scope.row.logo"
                        placement="right"
                        width="300"
                        trigger="click">
                            <el-image :src="scope.row.logo.path" fit="fill"/>
                            <i class="el-icon-picture-outline-round" slot="reference" />
                        </el-popover>
                        {{scope.row.name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="contact"
                label="联系人"
                width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="phone"
                label="联系电话"
                width="140"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="email"
                label="Email"
                width="260"
            ></el-table-column>
            <el-table-column
                prop="is_visible"
                label="公开可见"
                width="90"
                align="center"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                prop="top"
                label="置顶"
                width="90"
                align="center"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                prop="created_at"
                label="创建时间"
                width="140"
                :formatter="unixFormatter"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <el-button
                        @click="edit(scope.row)"
                        type="text"
                        size="mini"
                    >编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <ox-safe-button
                        @confirm="remove(scope.row)"
                        type="text"
                        size="small"
                    >删除</ox-safe-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="onPageChange"
                :page-size="pagination.size"
                :current-page="pagination.current"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { pageMixin, fmtMixin } from "@/ox/Mixins";
import OxSafeButton from '@/ox/components/OxSafeButton';


export default {
    name: "CompanyTable",
    mixins: [pageMixin, fmtMixin],
    components:{
        OxSafeButton
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            companies: []
        };
    },

    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.isLoading = true;
            const currentPage = page || this.page;
            const query = new window.BaaS.Query();
            const {filter} = this.$parent;
            if(filter.keyword){
                query.contains(filter.column, filter.keyword.trim())
            }
            this.$ox
                .service("company")
                .find(query, {
                    page: currentPage,
                    withCount: true,
                    orderBy: ["-top", "-updated_at"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.pagination.size = res.meta.limit;
                    this.pagination.total = res.meta.total_count;
                    this.pagination.current = currentPage;
                    this.page = currentPage;
                    this.companies = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        onPageChange(page) {
            this.loadData(page);
        },
        edit(row) {
            this.$parent.$refs.dialog.show(row)
        },
        remove(row){
            this.$ox.service('company').delete(row.id).then(()=>{
                this.companies = this.companies.filter(company=>company.id!==row.id)
                this.$notify.success({
                  title: '操作成功',
                  message: `公司${row.name}”已删除`
                });
            })
        }
    }
};
</script>

<style scoped>
.name{
    display: flex;
    justify-content:flex-start;
    align-items:center;
}
.name i{
    font-size:16px;
    color: #409EFF;
    display: inline-block;
    flex-shrink:0;
    flex-grow:0;
    margin-right:5px;
    cursor: pointer;
    vertical-align:middle;
    line-height:21px;
}
</style>
